module.exports = __webpack_public_path__ + "img/icon_submenu11dark.f995bb2e.svg";